import { createSlice } from '@reduxjs/toolkit';
import { IScheduledValue } from '../../../../dto';
import { setScheduledValue } from '../actions';
import { MN_SCHEDULED_VALUES, TYPE_ELEMENT } from '../../../../common';

export interface ScheduledValueState {
  data: IScheduledValue | null;
  loading: boolean;
  error: string | null;
}

const initialState: ScheduledValueState = {
  data: null,
  loading: false,
  error: null,
};

export const scheduledValueSlice = createSlice({
  name: `${MN_SCHEDULED_VALUES}/${TYPE_ELEMENT}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setScheduledValue, (state, { payload }) => {
      state.data = payload;
    });
  },
});
